import { Coins } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import type { ConsultationCosts } from '@/hooks/useConsultationCosts';

const EURO = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 });

/**
 * De kosten van het consult achter een knop, voor host-modus: de host heeft weinig ruimte, en de kosten zijn er wel
 * maar hoeven niet steeds in beeld. Dezelfde posten als de kostenregel, met een komma als decimaalteken.
 */
export function KostenKnop({ kosten }: { kosten: ConsultationCosts }) {
  const regels: [string, number][] = [
    ['Opname', kosten.recording],
    ['Vertaling', kosten.translation],
    ['SOEP-verslag', kosten.summarization],
    ['ICPC', kosten.icpc],
  ];
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="ghost" size="icon" className="h-7 w-7" data-vts="kostenknop" title="Kosten van dit consult" aria-label="Kosten van dit consult">
          <Coins className="h-3.5 w-3.5 text-muted-foreground" />
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-60 p-3 text-sm" data-vts="kostenpopup">
        <p className="mb-1.5 text-xs font-semibold text-muted-foreground">Kosten van dit consult</p>
        {regels
          .filter(([, bedrag]) => bedrag > 0)
          .map(([naam, bedrag]) => (
            <div key={naam} className="flex justify-between gap-4 py-0.5 tabular-nums">
              <span>{naam}</span>
              <span>{EURO.format(bedrag)}</span>
            </div>
          ))}
        <div className="mt-1 flex justify-between gap-4 border-t pt-1.5 font-semibold tabular-nums">
          <span>Totaal</span>
          <span>{EURO.format(kosten.total)}</span>
        </div>
      </PopoverContent>
    </Popover>
  );
}
